import { IIconBase } from '..'

const sharedIcon = ({
  color = '#333752',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/programming-arrows'>
        <g id='programming-arrows'>
          <path
            id='Vector'
            d='M11.0833 9.33333V3.79167C11.0833 3.15 10.5583 2.625 9.91658 2.625H6.70825'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.16675 1.1665L6.41675 2.62484L8.16675 4.08317'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M11.0833 12.8335C12.0498 12.8335 12.8333 12.05 12.8333 11.0835C12.8333 10.117 12.0498 9.3335 11.0833 9.3335C10.1168 9.3335 9.33325 10.117 9.33325 11.0835C9.33325 12.05 10.1168 12.8335 11.0833 12.8335Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M2.91675 4.6665V10.2082C2.91675 10.8498 3.44175 11.3748 4.08341 11.3748H7.29175'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M5.83325 12.8332L7.58325 11.3748L5.83325 9.9165'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M2.91675 4.6665C3.88325 4.6665 4.66675 3.883 4.66675 2.9165C4.66675 1.95001 3.88325 1.1665 2.91675 1.1665C1.95025 1.1665 1.16675 1.95001 1.16675 2.9165C1.16675 3.883 1.95025 4.6665 2.91675 4.6665Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default sharedIcon
